"use client";

import type React from "react"
import { ThemeProvider } from "@/components/theme-provider"
import AuthProvider from "@/components/auth-provider"
import { AuthGuard } from "@/components/auth-guard"
import { CompanyProvider } from "@/contexts/CompanyContext"
import { usePathname } from "next/navigation"

interface ClientLayoutProps {
  children: React.ReactNode
}

export default function ClientLayout({ children }: ClientLayoutProps) {
  const pathname = usePathname();
  const isLoginPage = pathname.includes('/login');
  const isLogoutPage = pathname.includes('/auth/logout');
  // /auth/import は SSO bridge 用。AuthGuard 通さずに token を localStorage に保存させる
  const isImportPage = pathname.includes('/auth/import');

  return (
    <AuthProvider>
      <CompanyProvider>
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
          {isLoginPage || isLogoutPage || isImportPage ? children : (
            <AuthGuard>
              {children}
            </AuthGuard>
          )}
        </ThemeProvider>
      </CompanyProvider>
    </AuthProvider>
  )
}
